const mobileStickyBar = document.querySelector('.mobile-sticky-bar');
const sectionsToHide = document.querySelectorAll('.hide-sticky-bar-section');

let cachedBarHeight = 56;
let cachedBodyHeight = 3000;
let valuesMeasured = false;
let resizeTicking = false;
let scrollTicking = false;

function updateCachedValues() {
  if (!mobileStickyBar) return;
  cachedBarHeight = mobileStickyBar.offsetHeight;
  cachedBodyHeight = document.body.offsetHeight;
  valuesMeasured = true;
}

function updateMobileStickyBarHeight() {
  let barHeight = `${cachedBarHeight}px`;
  if (window.innerWidth > 749) {
    barHeight = '0px';
  }
  document.documentElement.style.setProperty('--sticky-bar-height', barHeight);
}

function showmobileStickyBar() {
  if (!mobileStickyBar) return;
  if (!valuesMeasured) {
    updateCachedValues();
    updateMobileStickyBarHeight();
  }
  const endScreenOnScroll = cachedBodyHeight - window.innerHeight * 1.5;
  const scrollTop = window.scrollY || document.documentElement.scrollTop;

  if (
    scrollTop > window.innerHeight / 2 &&
    scrollTop < endScreenOnScroll &&
    !mobileStickyBar.classList.contains('js-hidden')
  ) {
    mobileStickyBar.classList.add('active');
  } else {
    mobileStickyBar.classList.remove('active');
  }
}

function hideBarWhenOverSections() {
  if (!('IntersectionObserver' in window) || !mobileStickyBar) return;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          mobileStickyBar.classList.add('js-hidden');
        } else {
          mobileStickyBar.classList.remove('js-hidden');
        }
      });
    },
    { root: null, threshold: 0 }
  );
  sectionsToHide.forEach((section) => observer.observe(section));
}

window.addEventListener('scroll', () => {
  if (!scrollTicking) {
    requestAnimationFrame(() => {
      showmobileStickyBar();
      scrollTicking = false;
    });
    scrollTicking = true;
  }
}, { passive: true });

window.addEventListener('load', () => {
  hideBarWhenOverSections();
}, { once: true });

window.addEventListener('resize', () => {
  if (!resizeTicking) {
    requestAnimationFrame(() => {
      updateCachedValues();
      updateMobileStickyBarHeight();
      resizeTicking = false;
    });
    resizeTicking = true;
  }
}, { passive: true });
